import { Pipe, PipeTransform } from '@angular/core';
import { AllMeasuresUnits } from 'convert-units/definitions/all';
import { DimensionSystemService } from '../../services/dimension-system.service';
import { TransferItemUnit } from '../../../pages/transfers/enum/transfer-item-unit.enum';

@Pipe({ name: 'dimensionSystemUnit', standalone: true })
export class DimensionSystemUnitPipe implements PipeTransform {
  constructor(private dimensionSystemService: DimensionSystemService) {}

  public transform(unit: string | AllMeasuresUnits | TransferItemUnit): string {
    return this.dimensionSystemService.toUserDimensionUnit(unit);
  }
}
